import { DATE_COLUMN_GROUP } from './constants';
import { DEFAULT_SPLIT_SORT, SplitSortBy } from './types';
import type { ChartMeta, SplitSort } from './types';

interface SplitSortHolder {
  splitDimension: string;
  primaryMetric: string;
  splitSort?: SplitSort;
}

export const isChronologicalSplit = (
  meta: ChartMeta | null,
  dimension: string,
): boolean =>
  meta?.config[dimension]?.group?.toLowerCase() === DATE_COLUMN_GROUP;

export const computeDefaultSplitSort = (
  meta: ChartMeta | null,
  dimension: string,
): SplitSort => ({
  by: isChronologicalSplit(meta, dimension)
    ? SplitSortBy.name
    : SplitSortBy.value,
  metric: '',
  direction: DEFAULT_SPLIT_SORT.direction,
});

export const healSplitSort = (
  chart: SplitSortHolder,
  meta: ChartMeta,
): SplitSort => {
  const current =
    chart.splitSort ?? computeDefaultSplitSort(meta, chart.splitDimension);

  const healed =
    current.metric && !meta.metrics.includes(current.metric)
      ? { ...current, metric: '' }
      : current;

  if (
    healed.by === SplitSortBy.value &&
    !(healed.metric || chart.primaryMetric)
  ) {
    return { ...healed, by: SplitSortBy.name };
  }

  return healed;
};
